<template lang="pug">
  .establishment-selector
    establishment-selector-list(
      :main-establishment="establishment"
      :potentialEstablishments="potentialEstablishments"
      @select="selectEstablishment"
      @hover="hoverHandler"
    )
    //- establishment-selector-preview(:establishment="selectedEstablishment")
    establishment-map(
      ref="previewMap"
      :establishmentSheets="sheetAggregates"
    )
</template>

<script>
import EstablishmentSelectorList from './EstablishmentSelectorList.vue';
import EstablishmentSelectorPreview from './EstablishmentSelectorPreview.vue';
import EstablishmentMap from '@/components/EstablishmentMap.vue';

export default {
  components: {
    EstablishmentSelectorList,
    EstablishmentSelectorPreview,
    EstablishmentMap,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
    sheetAggregates: {
      type: Array,
      default: () => [],
    },
    selectedEstablishment: {
      type: Object,
      default: null,
    },
    potentialEstablishments: {
      type: Array,
      default: () => [],
    },
  },
  mounted () {
    if (this.selectedEstablishment) {
      this.$refs.previewMap.addEstablishmentMarkers(this.selectedEstablishment);
    }
  },
  methods: {
    hoverHandler(establishment) {
      this.$refs.previewMap.addEstablishmentMarkers(establishment);
    },
    selectEstablishment(establishment) {
      this.$emit('select', establishment);
    },
  },
}
</script>

<style lang="scss">
  .establishment-selector {
    display: flex;
    flex-grow: 1;
    overflow-y: hidden;
    .establishment-map {
      flex-basis: 66%;
      height: 800px;
    }
    .establishment-selector-list {
      flex-basis: 33%;
      padding-right: 1em;
      border-right: 2px solid #CACACA;
    }
    .establishment-selector-preview {
      flex-grow: 1;
    }
  }
</style>